export const LOCATIONS = [
  {
    code: "EU",
    name: "Europe",
  },
  {
    code: "OUT",
    name: "Out of Belarus, Russia, Ukraine",
  },
  {
    code: "RU",
    name: "Russia",
  },
  {
    code: "BY",
    name: "Belarus",
  },
  {
    code: "UA",
    name: "Ukraine",
  },
  {
    code: "PL",
    name: "Poland",
  },
  {
    code: "LT",
    name: "Lithuania",
  },
  {
    code: "LV",
    name: "Latvia",
  },
  {
    code: "EE",
    name: "Estonia",
  },
  {
    code: "GE",
    name: "Georgia",
  },
  {
    code: "KZ",
    name: "Kazakhstan",
  },
];
